// @flow

import { type IncomingPayment } from './types';

export function needsCaptcha(incomingPayment: IncomingPayment): ?boolean {
  return incomingPayment['needs_captcha'];
}
